import { buildSort, goPromise } from "@delanobgt/admin-core/util/helpers";
import {
  ApiClientFactory,
  IMeta,
  IPagination,
  ISort,
} from "@delanobgt/admin-core/util/types";
import { CancelTokenSource } from "axios";
import _ from "lodash";

import {
  ELegitCheckBrandSortField,
  ILegitCheckBrand,
  PLegitCheckBrandFilter,
} from "../entities";
import ILegitCheckBrandRepository from "../repository";
import ILegitCheckBrandUpdateRequest from "../request/request";

export default class LegitCheckBrandRepository
  implements ILegitCheckBrandRepository<CancelTokenSource> {
  private apiClientFactory: ApiClientFactory;

  // api routes
  private LEGIT_CHECK_BRAND_ROUTE = "/admin/legit-check-brand";

  constructor(apiClientFactory: ApiClientFactory) {
    this.apiClientFactory = apiClientFactory;
  }

  buildFilter = (filter: PLegitCheckBrandFilter) => {
    return filter;
  };

  private getSignalToken(signal: CancelTokenSource) {
    return _.get(signal, "token", null);
  }

  private getError(error: any) {
    return _.get(error, "response.data.errors", "Something went wrong.");
  }

  async getLegitCheckBrand(
    pagination: IPagination,
    filter: PLegitCheckBrandFilter,
    sorts: ISort<ELegitCheckBrandSortField>[],
    signal?: CancelTokenSource
  ): Promise<[ILegitCheckBrand[], IMeta]> {
    const sort = buildSort(sorts);
    const params = _.pickBy(
      {
        ...pagination,
        ...this.buildFilter(filter),
      },
      Boolean
    );
    const [err, response] = await goPromise(
      this.apiClientFactory({ cancelToken: this.getSignalToken(signal) }).get(
        `${this.LEGIT_CHECK_BRAND_ROUTE}?${sort ? "sort=" + sort : ""}`,
        {
          params,
        }
      )
    );
    if (err) {
      throw this.getError(err);
    }
    const { data, meta } = response.data;
    return [data, meta];
  }

  async getLegitCheckBrandById(id: number): Promise<ILegitCheckBrand> {
    const [err, response] = await goPromise(
      this.apiClientFactory().get(`${this.LEGIT_CHECK_BRAND_ROUTE}/${id}`)
    );
    if (err) {
      throw this.getError(err);
    }
    return response.data;
  }

  async updateLegitCheckBrand(
    id: number,
    updateRequest: ILegitCheckBrandUpdateRequest
  ): Promise<void> {
    const [err] = await goPromise(
      this.apiClientFactory().patch(
        `${this.LEGIT_CHECK_BRAND_ROUTE}/${id}`,
        updateRequest
      )
    );
    if (err) {
      throw this.getError(err);
    }
  }

  async manualUpdateAllLegitCheckBrand(): Promise<void> {
    const [err] = await goPromise(
      this.apiClientFactory().post(`${this.LEGIT_CHECK_BRAND_ROUTE}/update`)
    );
    if (err) {
      throw this.getError(err);
    }
  }
}
